import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const USER_PANEL_DATE_TIME_FORMAT: DiToken<string | undefined> = new DiToken<string | undefined>(
  'userPanelDateFormat',
  {
    factory: () => undefined
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const USER_PANEL_DISPLAY_TIME_IN_LOCAL_TIME_ZONE: DiToken<boolean> = new DiToken<boolean>(
  'displayTimeInLocalTimeZone',
  {
    factory: () => false
  }
);
